// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Jblu","title-wrapper":"_3b9Yy"};